import { forwardRef } from "react";
import { QRCodeSVG } from "qrcode.react";
import { useCompany } from "../contexts/CompanyContext";

const NORMATIVA = `Ai sensi dell'art. 5 comma 1 della L. 13 agosto 2010 n. 136 e dell'art. 18 comma 1 lett. u) e art. 26 comma 8 del D.Lgs. 9 aprile 2008 n. 81, il presente tesserino è corredato di fotografia, generalità del lavoratore e indicazione del datore di lavoro. Da esibire a richiesta. La contraffazione costituisce reato.`;

const DEFAULT_FIRMA = "/brand/firma-datore.png";

export const BadgeBack = forwardRef(({ employee, firmaDatore, verifyBaseUrl, size = "std" }, ref) => {
    const company = useCompany();
    const matricola = employee?.matricola || "";
    const verifyUrl = `${verifyBaseUrl || ""}/verify/${encodeURIComponent(matricola || "")}`;
    const firma = firmaDatore || DEFAULT_FIRMA;

    return (
        <div ref={ref} className={`badge-card badge-back${size === "xl" ? " badge-card--xl" : ""}`} data-testid="badge-back">
            <div
                className="badge-watermark"
                style={{ backgroundImage: 'url("/brand/logo-s.jpg")' }}
                aria-hidden
            />
            <div className="badge-back-body">
                <div className="badge-back-title">
                    <div className="badge-back-title-main">{company.ragione_sociale}</div>
                    <div className="badge-back-title-sub">Tesserino di Riconoscimento</div>
                </div>

                <div className="badge-back-normativa">{NORMATIVA}</div>

                <div className="badge-back-bottom">
                    <div className="badge-back-firma-area">
                        <div className="firma-frame">
                            <img src={firma} alt="Firma datore" className="firma-img" />
                        </div>
                        <div className="firma-label">Il Datore di Lavoro</div>
                    </div>

                    <div className="badge-back-qr">
                        <div data-qr-region className="badge-back-qr-region">
                            {matricola ? (
                                <QRCodeSVG
                                    value={verifyUrl}
                                    size={62}
                                    level="M"
                                    bgColor="#FFFFFF"
                                    fgColor="#1D6FB8"
                                    includeMargin={false}
                                />
                            ) : (
                                <div className="badge-back-qr-placeholder">QR</div>
                            )}
                        </div>
                        <div className="badge-back-qr-label">Verifica online</div>
                    </div>
                </div>
            </div>
            <div className="badge-footer-bar" />
        </div>
    );
});

BadgeBack.displayName = "BadgeBack";
